<template>
  <div v-if="globals.isAccessAllowed('LoopOp_Surveys_ReadAll')">
    <!-- This component displays the survey management  -->

    <SurveyManagementEditModal
      :selectedSurvey="selectedSurvey"
      :showDialog="showEditSurveyDialog"
      :dialogModeAdd="editSurveyDialogModeAdd"
      :copySurvey="copySurvey"
      :languageList="languageList"
      :localesList="localesList"
      @surveyEditorRedirect="redirectToSurveyEditor"
      @dialogClosed="onEditSurveyDialogClosed"
      @dialogDataSaved="onEditSurveyDialogDataSaved"
    ></SurveyManagementEditModal>

    <SurveyManagementTranslateModal
      :selectedSurvey="selectedSurvey"
      :showDialog="showTranslateSurveyDialog"
      @dialogClosed="onTranslateSurveyDialogClosed"
    ></SurveyManagementTranslateModal>

    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="surveys-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <!-- Add buttons here  -->
          <button
            id="survey-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getSurveyData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.U0000 }}
          </button>
          <button
            id="survey-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Surveys_Create')"
            @click="
              (selectedSurvey = null),
                (editSurveyDialogModeAdd = true),
                (showEditSurveyDialog = true)
            "
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.U0001 }}
          </button>
          <button
            id="survey-management-edit-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Surveys_Read')"
            @click="
              (editSurveyDialogModeAdd = false), (showEditSurveyDialog = true)
            "
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.U0002 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Surveys_Create')"
            @click="
              (editSurveyDialogModeAdd = false),
                (showEditSurveyDialog = true),
                (copySurvey = true)
            "
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">content_copy</i>
            <br />
            {{ lang.U0034 }}
          </button>
          <button
            id="survey-management-delete-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Surveys_Delete')"
            @click="openDeleteSurveyDialog()"
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.U0003 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="
              globals.isAccessAllowed('LoopOp_Surveys_Read') &&
              globals.isAccessAllowed('LoopOp_Surveys_Update')
            "
            @click="redirectToSurveyEditor(selectedSurvey.SurveyId)"
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">playlist_add_check</i>
            <br />
            {{ lang.U0004 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_SurveyTranslation_Read')"
            @click="openSelectSurveyLanguageDialog(selectedSurvey.SurveyId)"
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">language</i>
            <br />
            {{ lang.U0037 }}
          </button>
          <!-- Export Download Button -->
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Survey_Export')"
            @click="downloadSurvey(selectedSurvey)"
            :disabled="!selectedSurvey"
          >
            <i class="material-icons md-36">get_app</i>
            <br />
            {{ lang.U0045 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-7">
          <!-- Searchbar - triggered by enter key -->
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.U0005"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getSurveyData()"
            />
          </div>
        </div>

        <div class="col-lg-5 nopadding">
          <!-- Pagination -->
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <!-- Dropdown: Select the number of elements per page -->
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.U0006 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <!-- Add dropdown entries here -->
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <!-- Jump to first page -->
            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.U0007 }}</b-tooltip
              >
            </li>
            <!-- ... -->
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <!-- Pagenumbers -->
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <!-- ... -->
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <!-- Jump to last page -->
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage == pageCount,
              }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.U0008 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="surveysTotalElementsCounter">{{
                totalElementsCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="surveysTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.U0044 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <table class="table table-striped table-hover main-table">
          <thead>
            <tr>
              <!-- Add table headers here -->
              <!-- The table sort is triggered by click on the header -->
              <th style="width: 8%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('SurveyId')"
                >
                  {{ lang.U0009 }}
                  <span
                    v-if="sortField == 'SurveyId' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyId' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 36%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('SurveyTitle')"
                >
                  {{ lang.U0010 }}
                  <span
                    v-if="sortField == 'SurveyTitle' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyTitle' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th
                style="width: 26%"
                class="text-center"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('ClientName')"
                >
                  {{ lang.U0011 }}
                  <span
                    v-if="sortField == 'ClientName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ClientName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 26%" class="text-center" v-else>
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('ImporterName')"
                >
                  {{ lang.U0043 }}
                  <span
                    v-if="sortField == 'ImporterName' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'ImporterName' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 10%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('SurveyCreatedAt')"
                >
                  {{ lang.U0012 }}
                  <span
                    v-if="sortField == 'SurveyCreatedAt' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyCreatedAt' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 14%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('CurrentUser')"
                >
                  {{ lang.U0035 }}
                  <span
                    v-if="sortField == 'CurrentUser' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'CurrentUser' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
              <th style="width: 6%" class="text-center">
                <a
                  class="table-header"
                  role="button"
                  @click="sortSurveyData('SurveyActive')"
                >
                  {{ lang.U0036 }}
                  <span
                    v-if="sortField == 'SurveyActive' && sortOrder == 'asc'"
                    class="glyphicon glyphicon-triangle-top"
                  ></span>
                  <span
                    v-if="sortField == 'SurveyActive' && sortOrder == 'desc'"
                    class="glyphicon glyphicon-triangle-bottom"
                  ></span>
                </a>
              </th>
            </tr>
            <tr class="table-filters">
              <th class="nopadding" style="width: 8%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.SurveyId"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 36%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.SurveyTitle"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th
                class="nopadding"
                style="width: 26%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.ClientName"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 26%" v-else>
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.ImporterName"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 10%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.SurveyCreatedAt"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 14%">
                <div class="form-group filterbar">
                  <input
                    type="search"
                    class="form-control text-center nopadding"
                    :placeholder="lang.U0014"
                    v-model="filterStrings.CurrentUser"
                    @keyup.enter="(selectedPage = 1), getSurveyData()"
                  />
                </div>
              </th>
              <th class="nopadding" style="width: 6%">
                <div class="form-group filterbar">
                  <a
                    role="button"
                    @click="
                      (filterStrings.SurveyActive =
                        (filterStrings.SurveyActive + 1) % 3),
                        getSurveyData()
                    "
                  >
                    <div
                      class="cb-active-filter-container"
                      v-if="filterStrings.SurveyActive === 1"
                    >
                      <i class="material-icons md-24">check_box</i>
                    </div>
                    <div
                      class="cb-active-filter-container"
                      v-else-if="filterStrings.SurveyActive === 0"
                    >
                      <i class="material-icons md-24"
                        >check_box_outline_blank</i
                      >
                    </div>
                    <div class="cb-active-filter-container" v-else>
                      <i class="material-icons md-24"
                        >indeterminate_check_box</i
                      >
                    </div>
                  </a>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="main-table-scrollbar">
            <!-- Doubleclick on the table row opens the edit dialog, singleclick selects the survey -->
            <tr
              role="button"
              v-for="survey in surveyData"
              :key="survey.SurveyId"
              @click="selectedSurvey = survey"
              @dblclick="
                (editSurveyDialogModeAdd = false), (showEditSurveyDialog = true)
              "
              :class="{ info: selectedSurvey && survey.SurveyGuid == selectedSurvey.SurveyGuid }"
            >
              <!-- Add table data here -->
              <td style="width: 8%">{{ survey.SurveyId }}</td>
              <td style="width: 36%">{{ survey.SurveyTitle }}</td>
              <td
                style="width: 26%"
                v-if="
                  !feature.isAudiTarget || !feature.isEnabled('audi_importers')
                "
              >
                {{ survey.ClientName }}
              </td>
              <td style="width: 26%" v-else>{{ survey.ImporterName }}</td>
              <td style="width: 10%">{{ survey.SurveyCreatedAt }}</td>
              <td style="width: 14%">{{ survey.CurrentUser }}</td>
              <td style="width: 6%; padding: 6px 0 0 0">
                <i
                  class="material-icons md-24 survey-active"
                  v-if="survey.SurveyActive"
                  >done</i
                >
                <i class="material-icons md-24 survey-inactive" v-else>clear</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Modal      * -->
    <!-- ******************* -->
    <!-- This modal is for the security check if a user tries to delete any survey -->
    <div
      class="modal fade"
      id="deleteSurvey"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.U0024 }}</b>
            </h4>
          </div>
          <div class="modal-body" v-if="selectedSurvey">
            <p>
              <b>{{ lang.U0025 }}</b>
            </p>
            <!-- Survey data is displayed here to let the user know which survey he is about to delete -->
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.U0026 }}</label>
              <label class="col-md-10 text-black">{{
                selectedSurvey.SurveyId
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.U0027 }}</label>
              <label class="col-md-10 text-black">{{
                selectedSurvey.SurveyTitle
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.U0028 }}</label>
              <label class="col-md-10 text-black">{{
                selectedSurvey.ClientName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.U0029 }}</label>
              <label class="col-md-10 text-black">{{
                selectedSurvey.SurveyCreatedAt
              }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <!-- Add modal buttons here -->
            <button
              id="survey-management-delete-false-dialog-button"
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.U0030 }}
            </button>
            <button
              id="survey-management-delete-true-dialog-button"
              type="button"
              class="btn btn-raised btn-warning"
              @click="deleteSurveyData()"
            >
              {{ lang.U0031 }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SurveyManagementEditModal from "./SurveyManagementEditModal";
import SurveyManagementTranslateModal from "./SurveyManagementTranslateModal";

export default {
  name: "SurveyManagement",
  components: {
    SurveyManagementEditModal,
    SurveyManagementTranslateModal,
  },
  mounted() {
    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    }
    this.globals.getLanguageList((callbackData) => {
      this.languageList = callbackData;
    });
    this.globals.getLocaleList((callbackData) => {
      this.localesList = callbackData;
    });

    $(window).on("resize", this.setTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once("currentUserInfoReceived", this.setTableHeight);
  },
  destroyed() {
    $(window).off("resize", this.setTableHeight);
    this.writeComponentSettingsToStore();
  },
  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#surveys-top-panel").height() +
          $("#app-navbar").height() +
          $(".main-table > thead").height() +
          47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/surveyManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/surveyManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName,
          });
        }
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName,
          });
        }
      }
    },
    // Gets executed after the editSurveyDialog successfully saved some data
    onEditSurveyDialogDataSaved(survey) {
      this.getSurveyData(); // Refresh datatable
      if (survey) this.selectedSurvey = survey;
    },
    // Gets executed after the editSurveyDialog got closed
    onEditSurveyDialogClosed() {
      this.showEditSurveyDialog = false;
      this.copySurvey = false;
    },
    // Redirects to the survey editor component in a new tab to edit the survey with the given ID
    redirectToSurveyEditor(surveyId) {
      $.ajax({
        method: "PATCH",
        url: "api/Surveys/" + surveyId + "/Lock",
        data: '{ "Lock": true }',
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
          else {
            this.$router.push({
              path: "surveyeditor",
              query: { id: surveyId },
            });
          }
        },
        error: () => {
          console.error("Error on PUT in redirectToSurveyEditor()");
          this.globals.showErrorSnackbar("Survey lock failed");
        },
      });
    },
    // Opens the security check dialog for deleting the selected survey
    openDeleteSurveyDialog() {
      $("#deleteSurvey").modal("show");
    },
    // Opens the dialog to select Survey language and then translate
    openSelectSurveyLanguageDialog() {
      this.showTranslateSurveyDialog = true;
    },
    // Gets executed after the translateSurveyDialog got closed
    onTranslateSurveyDialogClosed() {
      this.showTranslateSurveyDialog = false;
    },
    // Sends a delete request for the selected survey to the server
    deleteSurveyData() {
      $.ajax({
        method: "DELETE",
        url: "api/Surveys/" + this.selectedSurvey.SurveyId,
        success: (data) => {
          // If delete was successful, refresh displayed data and hide dialog
          $("#deleteSurvey").modal("hide");
          if (data.Error) this.globals.showErrorSnackbar(data.Error);
          else this.globals.showSuccessSnackbar("Survey deletion successful");
          this.selectedSurvey = null;
          this.getSurveyData();
        },
        error: () => {
          console.error("Survey data deletion failed in deleteSurveyData()");
          this.globals.showErrorSnackbar("Survey deletion failed");
        },
      });
    },
    // Calculates the sort order for the given column and refreshes the displayed data
    sortSurveyData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getSurveyData();
    },
    // Catches survey data for the table from the server, including current filter, pagination and sort settings
    getSurveyData() {
      this.refreshEnabled = false; // Disable refresh, so it can not be triggered again until the server responded

      let getString = `api/Surveys/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;
      getString = encodeURI(getString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        if (key === "SurveyActive" && value < 2) return true;
        return value.length > 0;
      });
      if (typeof filter.SurveyActive === "number")
        filter.SurveyActive = !!filter.SurveyActive;

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (typeof data[0] == "undefined") {
            this.surveyData = [];
            this.pageCount = 1;
          } else {
            this.surveyData = data[0].Surveys; // If GET was successful, store survey data and page count from server
            this.pageCount = data[0].Page_Count;
            this.totalElementsCount = data[0].Count;
          }
        },
        error: () => {
          console.error("Error on POST in getSurveyData()");
          this.globals.showErrorSnackbar("Survey data access failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    // Updates the current pagesize and the selected pagenumber and triggers the refresh of the table
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getSurveyData();
    },
    // Returns a range of numbers with min-value, max-value and stepsize
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    // Returns a list of all pagenumbers that should be visible depending on the current page and the count of pages
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
    // Export and download of survey
    downloadSurvey(selectedSurvey) {
      if (!selectedSurvey) return;
      let query = `api/Surveys/${selectedSurvey.SurveyGuid}/Export`;

      $.ajax({
        method: "GET",
        url: query,
        success: (data) => {
          if (data.Error) {
            this.globals.showErrorSnackbar(data.Error);
            console.error(data.Error);
            return;
          }
          this.globals.downloadFile(data[0].DownloadId);
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          console.error("Survey Export failed");
          console.error(`${XMLHttpRequest} ${textStatus} : ${errorThrown}`);
          this.globals.showErrorSnackbar(this.lang.U0046);
        },
      });
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
      this.getSurveyData();
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedSurvey: null, // ID of the selected survey
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        SurveyId: "",
        SurveyTitle: "",
        ClientName: "",
        ImporterName: "",
        SurveyCreatedAt: "",
        CurrentUser: "",
        SurveyActive: 2,
      },
      showActiveSurveys: 2, // 0 = inactive, 1 = active, 2 = all
      sortField: "SurveyTitle", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      surveyData: [], // Stores the survey data on the current page
      showEditSurveyDialog: false,
      editSurveyDialogModeAdd: true,
      copySurvey: false,
      languageList: {},
      localesList: [],
      showTranslateSurveyDialog: false,
      lang: {
        // Contains localization strings for the selected language
        U0000: "Refresh",
        U0001: "Add",
        U0002: "Edit",
        U0003: "Delete",
        U0004: "Survey Editor",
        U0005: "Search...",
        U0006: "Items per page",
        U0007: "First page",
        U0008: "Last page",
        U0009: "SID",
        U0010: "Title",
        U0011: "Client",
        U0012: "Created",
        U0013: "In use",
        U0014: "Filter",
        U0022: "Cancel",
        U0023: "Save",
        U0024: "Delete Survey",
        U0025: "Do you really want to delete the following survey?",
        U0026: "SID",
        U0027: "Title",
        U0028: "Client",
        U0029: "Created",
        U0030: "No",
        U0031: "Yes",
        U0034: "Copy",
        U0035: "Used by",
        U0036: "Active",
        U0037: "Translation",
        U0038: "Language selection",
        U0039: "Continue",
        U0043: "Importer",
        U0044: "Total surveys count",
        U0045: "Export",
        U0046: "Survey export failed",
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cb-active-filter-container {
  margin-top: 7px;
  color: var(--color-primary-input);
}

td > .survey-active {
  padding: 0px;
  color: green;
}
td > .survey-inactive {
  padding: 0px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// SurveyManagement.vue?08dce5e0